// Reference: https://30secondsofcode.org/#findlast
const findLastIndex = (dates, fn) => {
  const [lastDay] = [...dates].sort((a, b) => b - a);
  if (lastDay < new Date()) return dates.indexOf(lastDay);
  return dates
    .map((val, i) => [i, val])
    .filter(([i, val]) => fn(val, i, dates))
    .pop()[0];
};

export default class Calendar {
  constructor() {
    this.frameEL = document.querySelector('.frame--calendar');
    this.listEL = this.frameEL.querySelector('#events-list');
    this.itemsEL = this.listEL.querySelectorAll('.event'); // items come sorted in descrescent order
    this.maxLen = this.itemsEL.length;
    this.btnDown = this.frameEL.querySelector('[data-button="calendar-down"]');
    this.btnUp = this.frameEL.querySelector('[data-button="calendar-up"]');
    this.elHeight = this.itemsEL[0].offsetHeight;
    this.current = 0;
  }

  disableBtnDown() {
    if (this.current === (this.maxLen - 2)) {
      this.btnDown.classList.add('button--disabled');
    }
  }

  disableBtnUp() {
    if (this.current <= 1) {
      this.btnUp.classList.add('button--disabled');
    }
  }

  /**
   * moves the list elements up and down
   * takes the current element index and uses the translateY property to move all elements the same
   * amount of pixles (which is the height of the element itself times the index)
   */
  moveList() {
    [].forEach.call(this.itemsEL, item => item.style.transform = `translateY(-${(this.current - 1) * this.elHeight}px)`); // eslint-disable-line
  }

  /**
   * mobile only
   * sets the parent list of events' height for layout purposes
   * on desktop the frames must have the same height, so it's defined on CSS itself
   */
  setListHeight() {
    if (document.documentElement.clientWidth <= 1024) {
      this.listEL.style.maxHeight = 3 * this.elHeight;
    }
  }

  /**
   * gets the index of the next event according to today's date
   * @returns {Number} the index of the next event's
   */
  setCurrentEvent() {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today = today.setMilliseconds(0);

    const dates = [].map.call(this.itemsEL, ((item) => {
      const dateAttr = item.getAttribute('data-date');
      const [day, month, year] = dateAttr.split('-');
      return new Date(Number(year), (Number(month) - 1), Number(day), 0, 0, 0, 0);
    }));

    const idx = findLastIndex(dates, (date => (today - date) <= 0));
    return idx;
  }

  /**
   * configure the calendar:
   * - set the list height
   * - set the position of items according to the date
   * - add buttons click event
   */
  initCalendar() {
    // sets a max-height for the list content, layout only
    this.setListHeight();

    // checks which event will be the next one and move agenda accordingly
    // const nextEvent = this.setCurrentEvent();
    this.current = this.setCurrentEvent();
    if (this.current > 1) {
      this.moveList(this.current, this.itemsEL);
    }

    if (this.current >= (this.itemsEL.length - 2)) {
      this.disableBtnDown();
    } else if (this.current <= 1) {
      this.disableBtnUp();
    }


    // slides the agenda down
    this.btnDown.addEventListener('click', () => {
      this.btnUp.classList.remove('button--disabled');
      if (this.current < (this.maxLen - 2)) {
        this.current += 1;
        this.moveList();
        this.disableBtnDown();
      } else {
        console.error('cant move down'); // eslint-disable-line
      }
    });

    // slides the agenda up
    this.btnUp.addEventListener('click', () => {
      this.btnDown.classList.remove('button--disabled');
      if (this.current > 1) {
        this.current -= 1;
        this.moveList();
        this.disableBtnUp();
      } else {
        console.error('cant move up'); // eslint-disable-line
      }
    });
  }
}



// WEBPACK FOOTER //
// local_static/templates/especiais/verao_espetacular/assets/scripts/calendar.js